<div class='doctors-main' data-cy="fee-discounts-container">
  <mat-progress-spinner *ngIf="!discountList" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="fee-discounts-spinner"></mat-progress-spinner>
  <mat-grid-list *ngIf="discountList" cols="6" rowHeight="100%" style="height:100%;" data-cy="fee-discounts-grid">
    <mat-grid-tile colspan="2" data-cy="fee-discounts-doctors-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%);" data-cy="fee-discounts-doctors-card">
        <span class="configuration-section-title" data-cy="fee-discounts-doctors-title">Fee Adjustment For Doctor</span>
        <div style="height: calc(100%)" data-cy="fee-discounts-doctors-table-container">
          <tdo-table [dataSource]="doctorList" (rowSelected)="onDoctorSelected($event)" data-cy="fee-discounts-doctors-table">
            <tdo-table-column displayName="First" targetObjectName="dataContact" propertyName="FirstName" [rowTemplate]="first" data-cy="fee-discounts-doctors-first-column">
              <ng-template #first let-row>{{row.FirstName}}</ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Last" targetObjectName="dataContact" propertyName="LastName" [rowTemplate]="last" data-cy="fee-discounts-doctors-last-column">
              <ng-template #last let-row>{{row.LastName}}</ng-template>
            </tdo-table-column>
            <!--<tdo-table-column displayName="" propertyName="xauditDeleted" [rowTemplate]="del">
              <ng-template #del let-row><div style="width: 30px; cursor: pointer; color: var(&#45;&#45;tdo-secondary); margin-left: auto; margin-right: 0;" (click)="deleteAdjustment()"><mat-icon>delete</mat-icon></div></ng-template>
            </tdo-table-column>-->
          </tdo-table>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="selectedDoctor" colspan="4" data-cy="fee-discounts-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" *ngIf="selectedDoctor" data-cy="fee-discounts-detail-card">
        <mat-card-content data-cy="fee-discounts-detail-content">

        <div style="max-width: 700px;" data-cy="fee-discounts-detail-container">
          <span class="configuration-section-title" data-cy="fee-discounts-detail-title">Fee adjustment</span>
          <app-tdo-configuration-action-bar
            [showEdit]="saveDisabled"
            [saveDisabled]="saveDisabled"
            [showSave]="!saveDisabled"
            [showCancel]="!saveDisabled"
            [newHidden]="true"
            [showAdd]="false"
            (saveClick)="onSave($event)"
            (cancelClick)="onCancel($event)"
            (editClick)="onEdit($event)"
            data-cy="fee-discounts-action-bar">
          </app-tdo-configuration-action-bar>

          <div style="padding-bottom: 20px" data-cy="fee-discounts-doctor-name-container">
            <span class="configuration-section-title" data-cy="fee-discounts-doctor-name">{{ currentDoctorName }}</span>
          </div>

          <div class="dropdown-list-container" data-cy="fee-discounts-client-container">
<!--            <span class="configuration-section-title">Clients</span>-->
            <br/>
            <mat-form-field class="dropdown-list" data-cy="fee-discounts-client-field">
              <mat-label data-cy="fee-discounts-client-label">Practice (Licensee)</mat-label>
              <mat-select [(value)]="selectedClient" (selectionChange)="onChangeClient($event)" [disabled]="isEditing" data-cy="fee-discounts-client-select">
                <mat-option *ngFor="let client of clientList" [value]="client" data-cy="fee-discounts-client-option">
                  {{client.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="dropdown-list-container" data-cy="fee-discounts-location-container">
<!--            <span class="configuration-section-title">Locations</span>-->
            <br/>
            <mat-form-field class="dropdown-list" data-cy="fee-discounts-location-field">
              <mat-label data-cy="fee-discounts-location-label">Locations</mat-label>
              <mat-select [(value)]="selectedLocation" (selectionChange)="onChangeLoc($event)" [disabled]="isEditing" data-cy="fee-discounts-location-select">
                <mat-option *ngFor="let loc of locationList" [value]="loc" data-cy="fee-discounts-location-option">
                  {{loc.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="dropdown-list-container" data-cy="fee-discounts-adjustments-container">

            <span class="configuration-section-title" data-cy="fee-discounts-adjustments-title">Doctor Adjustments</span>

            <br /><br />

            <div *ngIf="isBusyDoctorLocation" style="padding-top: 100px" data-cy="fee-discounts-loading-container">
              <mat-progress-spinner style="margin-left: auto; margin-right: auto; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="fee-discounts-loading-spinner"></mat-progress-spinner>
            </div>
            <div *ngIf="!isBusyDoctorLocation" data-cy="fee-discounts-levels-container">

              <!-- level 1 -->
              <div class="flex-container" data-cy="fee-discounts-level1-container">
                <div class="item-title" data-cy="fee-discounts-level1-title">Level 1</div>
                <div data-cy="fee-discounts-level1-amount-radio-container">
                  <mat-radio-button [name]="'level1'" value="1" [checked]="!currentPercentChecked1" (change)="radioChanged($event); configurationService.setDirty();" [disabled]="saveDisabled" data-cy="fee-discounts-level1-amount-radio"></mat-radio-button>
                </div>
                <div data-cy="fee-discounts-level1-amount-field-container">
                  $&nbsp;&nbsp;
                  <mat-form-field class="item-textbox" data-cy="fee-discounts-level1-amount-field">
                    <input matInput placeholder="Amount" [(ngModel)]="currentAmount1" [disabled]="saveDisabled" (input)="configurationService.setDirty();" data-cy="fee-discounts-level1-amount-input">
                  </mat-form-field>
                </div>
                <div data-cy="fee-discounts-level1-percent-radio-container">
                  <mat-radio-button [name]="'level1'" value="2" [checked]="currentPercentChecked1" (change)="radioChanged($event); configurationService.setDirty();" [disabled]="saveDisabled" data-cy="fee-discounts-level1-percent-radio"></mat-radio-button>
                </div>
                <div data-cy="fee-discounts-level1-percent-field-container">
                  <mat-form-field class="item-textbox" data-cy="fee-discounts-level1-percent-field">
                    <input matInput placeholder="Percent" [(ngModel)]="currentPercent1" [disabled]="saveDisabled" (input)="configurationService.setDirty();" data-cy="fee-discounts-level1-percent-input">
                  </mat-form-field>
                  &nbsp;&nbsp;%
                </div>
              </div>

              <!-- level 2 -->

              <div class="flex-container" data-cy="fee-discounts-level2-container">
                <div class="item-title" data-cy="fee-discounts-level2-title">Level 2</div>
                <div data-cy="fee-discounts-level2-amount-radio-container">
                  <mat-radio-button [name]="'level2'" value="1" [checked]="!currentPercentChecked2" (change)="radioChanged($event)" [disabled]="saveDisabled" data-cy="fee-discounts-level2-amount-radio"></mat-radio-button>
                </div>
                <div data-cy="fee-discounts-level2-amount-field-container">
                  $&nbsp;&nbsp;
                  <mat-form-field class="item-textbox" data-cy="fee-discounts-level2-amount-field">
                    <input matInput placeholder="Amount" [(ngModel)]="currentAmount2" [disabled]="saveDisabled" data-cy="fee-discounts-level2-amount-input">
                  </mat-form-field>
                </div>
                <div data-cy="fee-discounts-level2-percent-radio-container">
                  <mat-radio-button [name]="'level2'" value="2" [checked]="currentPercentChecked2" (change)="radioChanged($event)" [disabled]="saveDisabled" data-cy="fee-discounts-level2-percent-radio"></mat-radio-button>
                </div>
                <div data-cy="fee-discounts-level2-percent-field-container">
                  <mat-form-field class="item-textbox" data-cy="fee-discounts-level2-percent-field">
                    <input matInput placeholder="Percent" [(ngModel)]="currentPercent2" [disabled]="saveDisabled" data-cy="fee-discounts-level2-percent-input">
                  </mat-form-field>
                  &nbsp;&nbsp;%
                </div>
              </div>

              <!-- level 3 -->

              <div class="flex-container" data-cy="fee-discounts-level3-container">
                <div class="item-title" data-cy="fee-discounts-level3-title">Level 3</div>
                <div data-cy="fee-discounts-level3-amount-radio-container">
                  <mat-radio-button [name]="'level3'" value="1" [checked]="!currentPercentChecked3" (change)="radioChanged($event)" [disabled]="saveDisabled" data-cy="fee-discounts-level3-amount-radio"></mat-radio-button>
                </div>
                <div data-cy="fee-discounts-level3-amount-field-container">
                  $&nbsp;&nbsp;
                  <mat-form-field class="item-textbox" data-cy="fee-discounts-level3-amount-field">
                    <input matInput placeholder="Amount" [(ngModel)]="currentAmount3" [disabled]="saveDisabled" data-cy="fee-discounts-level3-amount-input">
                  </mat-form-field>
                </div>
                <div data-cy="fee-discounts-level3-percent-radio-container">
                  <mat-radio-button [name]="'level3'" value="2" [checked]="currentPercentChecked3" (change)="radioChanged($event)" [disabled]="saveDisabled" data-cy="fee-discounts-level3-percent-radio"></mat-radio-button>
                </div>
                <div data-cy="fee-discounts-level3-percent-field-container">
                  <mat-form-field class="item-textbox" data-cy="fee-discounts-level3-percent-field">
                    <input matInput placeholder="Percent" [(ngModel)]="currentPercent3" [disabled]="saveDisabled" data-cy="fee-discounts-level3-percent-input">
                  </mat-form-field>
                  &nbsp;&nbsp;%
                </div>
              </div>

            </div>
          </div>
        </div>

        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
